import React from 'react';

export default function StoreOfflineBanner({ message }) {
     return (
          <div
               role='alert'
               className='rounded-2xl border-2 border-yellow bg-yellow/10 p-5 laptop:p-6 mb-8 flex flex-col tablet:flex-row items-start gap-4'
          >
               <div className='flex-shrink-0 w-10 h-10 rounded-full bg-yellow text-dark font-bold flex items-center justify-center text-lg'>
                    !
               </div>
               <div className='flex-1'>
                    <p className='text-darker uppercase tracking-widest font-bold text-sm mb-1'>
                         Booking Temporarily Closed
                    </p>
                    <p className='text-darker whitespace-pre-line leading-relaxed'>
                         {message}
                    </p>
               </div>
          </div>
     );
}
